<template>
  <b-modal
    :hide-footer="true"
    centered
    id="tipo-compromisso-edit-modal"
    @hidden="$bvModal.hide('tipo-compromisso-edit-modal')"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Tipo de Compromisso
      </strong>
    </template>
    <form v-if="item?.editavel" @submit.prevent="atualizarTipoCompromisso(item)">
      <section class="row">
        <form-input
          :required="true"
          v-model="item.descricao"
          label="Descrição"
          grid="12"
        />

        <div class="col-12 d-flex align-items-center">
          <div class="float-left mr-2">
            <toggle-button
              :sync="true"
              color="#5685D8"
              id="motivo_obrigatorio"
              name="motivo_obrigatorio"
              v-model="item.motivo_obrigatorio"
            />
          </div>
          Motivo reagendamento obrigatório?
        </div>
      </section>
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-submit-edit-tipo-compromisso btn-success mr-0"
          data-style="zoom-in"
          type="submit"
        >
          {{ $t("Atualizar") }}
          <i class="mdi mdi-check"/>
        </button>
      </section>
    </form>
    <div class="row" v-else>
      <div class="col-12">
        <div class="alert alert-secondary" role="alert">
          O Tipo de compromisso <b>"{{ item.descricao }}"</b>
          é padrão do sistema e não pode ser editado. Apenas
          tipos de compromissos que não são padrões podem ser editados.
          <ul class="pl-3 mt-3">
            <li>
              <b>Descrição:</b>
              <span>{{ item.descricao }}.</span>
            </li>
            <li>
              <b>Motivo reagendamento obrigatório:</b>
              <span>{{ item.motivo_obrigatorio ? "Sim" : "Não" }}.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["item", "atualizarTipoCompromisso"],
}
</script>
